import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function MenuCard({
  to,
  menuId,
  IconComponent,
  iconColor,
  iconBg,
  label,
  onClick,
}) {
  const { permitAlarm } = useSelector((s) => s.permit);
  const { workStopAlarm, stopWorking } = useSelector((s) => s.workingCheck);
  const { equipReceiptAlarm } = useSelector((s) => s.equipment);
  const Wrapper = to ? Link : 'button';
  const isPermitMenu = menuId === 'M_Permit' || label === '작업 허가서';
  const isWorkStopMenu =
    menuId === 'M_WorkStop' || menuId === 'M_WorkStop/write';
  const isWorkStopApproveMenu = menuId === 'M_WorkStop/list';
  const isEquipmentMenu = menuId === 'M_Equipment';

  return (
    <Wrapper
      to={to}
      onClick={onClick}
      className="relative flex aspect-square w-full flex-col items-center justify-center gap-2 rounded-2xl border border-slate-100 bg-white shadow-sm transition-all active:scale-95"
    >
      <div
        className="relative flex aspect-square w-2/6 items-center justify-center rounded-full"
        style={{ backgroundColor: iconBg }}
      >
        <IconComponent className="h-5/6 w-5/6" color={iconColor} />

        {isPermitMenu && (permitAlarm === '요청' || permitAlarm === '반려') && (
          <span
            className={`absolute -bottom-1 left-1/2 z-10 -translate-x-1/2 rounded-full px-2 py-0.5 text-[8px] font-bold whitespace-nowrap text-white shadow-sm ${permitAlarm === '요청' ? 'bg-blue-500' : 'bg-red-400'}`}
          >
            {permitAlarm === '요청' ? '승인요청' : '반려'}
          </span>
        )}
        {isWorkStopMenu && stopWorking === 1 && (
          <span className="alarm-icon-blink absolute -bottom-1 left-1/2 z-10 -translate-x-1/2 rounded-full bg-red-500 px-2 py-0.5 text-[8px] font-bold whitespace-nowrap text-white shadow-sm">
            상황발생
          </span>
        )}
        {isWorkStopApproveMenu && workStopAlarm === '요청' && (
          <span className="absolute -bottom-2 left-1/2 z-10 -translate-x-1/2 rounded-full bg-blue-500 px-2 py-0.5 text-[8px] font-bold whitespace-nowrap text-white shadow-sm">
            승인요청
          </span>
        )}
        {isEquipmentMenu && equipReceiptAlarm === '수령하기' && (
          <span className="absolute -bottom-1 left-1/2 z-10 -translate-x-1/2 rounded-full bg-blue-500 px-2 py-0.5 text-[8px] font-bold whitespace-nowrap text-white shadow-sm">
            수령하기
          </span>
        )}
      </div>

      <span className="text-2xs font-bold tracking-tight text-slate-700">
        {label}
      </span>
    </Wrapper>
  );
}
